"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fakeApiServiceFactory = function (fakeData, disableSetTimeout) { return function (url, options) {
    return new Promise(function (resolve) {
        if (!fakeData) {
            throw new Error('Please ensure you have fakeData passed');
        }
        if (!url) {
            throw new Error('Please ensure you have url passed');
        }
        var key = Object.keys(fakeData).find(function (k) { return new RegExp(k + "$").test(url); });
        if (!key) {
            throw new Error("Please ensure you have this url in fake data: " + url);
        }
        var response = fakeData[key][options.method || ''];
        if (!response) {
            throw new Error("Please ensure you have this method in url: " + url + " - " + options.method);
        }
        if (disableSetTimeout) {
            resolve({
                status: response.status,
                text: function () { return Promise.resolve(response.body); },
            });
        }
        else {
            setTimeout(function () {
                resolve({
                    status: response.status,
                    text: function () { return Promise.resolve(response.body); },
                });
            }, 100);
        }
    });
}; };
exports.default = fakeApiServiceFactory;
//# sourceMappingURL=fakeApiServiceFactory.js.map